/** @file resetSlots: every facet entry of a puppet emptied (slots {}), flattened attachments included. */
import type { Puppet } from '@zilo/pose3d-format/types/puppet';

/**
 * `puppet` with every impostor and effect entry's `slots` set to `{}`. Sheets stay: the format requires every
 * entry's `sheet` to name one, so a template's sheet images remain until `sheet.upload` replaces them.
 */
export function resetSlots(puppet: Puppet): Puppet {
  for (const d of puppet.drawables) {
    const facets = d.kind === 'impostor' || d.kind === 'effect' ? (d.facets ?? []) : [];
    for (const entry of facets) entry.slots = {};
  }
  return puppet;
}
